<div class="card" [ngClass]="klass">
    <ng-content></ng-content>
</div>